export default "__VITE_ASSET__WYrnw3m7__"